import { render, staticRenderFns } from "./schedule-message-dialog.vue?vue&type=template&id=704d7f7f&scoped=true&"
import script from "./schedule-message-dialog.vue?vue&type=script&lang=js&"
export * from "./schedule-message-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704d7f7f",
  null
  
)

export default component.exports